import { apiGetRequest } from '../../../../utils/api/get';
import { ChargerStatusResponse, ChargerStatusFilters } from '../../model/reports';
import { BASE_URL } from '../../../../utils/auth';

export const fetchChargerStatusAPI = (
  token: string,
  filters: ChargerStatusFilters
): Promise<ChargerStatusResponse> =>
  apiGetRequest<ChargerStatusResponse>({
    apiUrl: `${BASE_URL}/reports/charger-status`,
    token,
    params: {
      vendorId: filters.vendorId,
      stationId: filters.stationId,
    },
  });
